import { Card } from '@analytical-alley/ui';

export const CampaignCardSkeleton = () => (
    <Card className="relative overflow-visible flex flex-col w-full border-2 border-transparent animate-pulse">
        {/* Campaign Name with Icon */}
        <div className="flex flex-wrap items-start sm:items-center gap-3 mb-2">
            <div className="shrink-0 mt-1">
                <div className="md:w-10 md:h-10 sm:w-6 sm:h-6 rounded-lg bg-gray-200" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="h-5 bg-gray-200 rounded w-3/4 mb-1" />
            </div>
            <div className="flex items-center gap-2 ml-auto basis-full sm:basis-auto justify-end">
                <div className="h-6 w-20 bg-gray-200 rounded-full" />
                <div className="h-8 w-8 bg-gray-200 rounded" />
            </div>
        </div>

        {/* Campaign Details */}
        <div className="space-y-3 mb-5">
            {/* Budget */}
            <div className="flex items-center gap-3">
                <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" />
                <div className="flex-1 space-y-2">
                    <div className="h-3 bg-gray-200 rounded w-12" />
                    <div className="h-4 bg-gray-200 rounded w-24" />
                </div>
            </div>

            {/* Period */}
            <div className="flex items-center gap-3">
                <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" />
                <div className="flex-1 space-y-2">
                    <div className="h-3 bg-gray-200 rounded w-24" />
                    <div className="h-4 bg-gray-200 rounded w-40" />
                </div>
            </div>

            {/* Review Status */}
            <div className="h-6 w-24 bg-gray-200 rounded" />
        </div>

        {/* Divider */}
        <div className="border-t border-gray-100 mb-4" />

        {/* CTA Section */}
        <div className="flex flex-col gap-2">
            <div className="h-9 bg-gray-200 rounded w-full" />
            <div className="h-3 bg-gray-200 rounded w-3/4 self-center mt-2" />
        </div>
    </Card>
);
